import React from 'react';
import { NavLink, useRouteMatch } from "react-router-dom";
import { Navbar, Nav } from 'react-bootstrap';
import Avatar from 'react-avatar';

import '../Styles/Components/AppNavbar.scss';

function AppNavbar(props) {

    var matchPath = useRouteMatch().path;

    var newsRoomPath = "/NewsRoom";
    var theWallPath = "/";
    var roadmapPath = "/Roadmap";

    var provider = props.provider;
    var account = provider.account;

    // console.log(matchPath)
    return (
        <div>
            <Navbar expand="lg">
                <NavLink className="AppNavbar--Brand-Link" to="/" exact={true}>
                    <img
                        alt=""
                        src="/images/logo.png"
                        className="d-inline-block align-bottom AppNavbar--Brand-Link--Img"
                    />
                    <p className="AppNavbar--Brand-Link--Text">5th</p>
                </NavLink>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="mr-auto">
                        {/* <NavLink className="AppNavbar--Link" activeClassName="Active-Link" exact to="/">Home</NavLink>s */}

                        {/* <NavLink className="AppNavbar--Link" activeClassName="Active-Link" to={newsRoomPath}>
                            <img
                                alt=""
                                src={newsRoomPath === matchPath ? "/images/newsroom_icon_active.png" : "/images/newsroom_icon.png"}
                                className="d-inline-block align-top AppNavbar--Link--Img"
                            />
                            News Room
                        </NavLink>
                        <NavLink className="AppNavbar--Link" activeClassName="Active-Link" to={theWallPath} exact={true}>
                            <img
                                alt=""
                                src={theWallPath === matchPath ? "/images/thewall_icon_active.png" : "/images/thewall_icon.png"}
                                className="d-inline-block align-top AppNavbar--Link--Img"
                            />
                            The Wall
                        </NavLink>
                        <NavLink className="AppNavbar--Link" activeClassName="Active-Link" to={roadmapPath}>
                            <img
                                alt=""
                                src={roadmapPath === matchPath ? "/images/roadmap_icon_active.png" : "/images/roadmap_icon.png"}
                                className="d-inline-block align-top AppNavbar--Link--Img"
                            />
                            Roadmap
                        </NavLink> */}
                    </Nav>
                    <div className="AppNavbar--Profile-Container">
                        <p className="AppNavbar--Profile-Container--UserName">{account.name}</p>
                        <Avatar name={account.name} round={true} textSizeRatio={2.5} size="40px" color="White" maxInitials={2} className="AppNavbar--Profile-Container--Avatar" />
                    </div>
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default AppNavbar;